import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../../shared/_services/theme.service';
import { ApiService } from '../../../shared/_services/api.service';
import { ProductGroup } from '../../../shared/_model/product-group.model';
import { TENANT_MAP } from '../../../core/tenant.config';
import { restoreSession, StepsDataService } from '../../../shared/_services/steps-data.service';
import { StepProgressService } from '../../../shared/_services/step-progress.service';
import { ChangeLanguageComponent } from '../../components/change-language/change-language.component';
import { DescriptionLinesPipe } from '../../../shared/_pipes/description-lines.pipe';

const TENANT_ID = TENANT_MAP['landing-page-imatra'];

@Component({
	selector: 'app-landing-imatra',
	standalone: true,
	imports: [CommonModule, FormsModule, TranslatePipe, ChangeLanguageComponent, DescriptionLinesPipe],
	templateUrl: './landing-imatra.component.html',
})
export class LandingImatraComponent implements OnInit, AfterViewInit {
	gruppi: ProductGroup[] = [];
	showScrollTop = false;
	mobileNavOpen = false;

	@ViewChildren('accordionButton') accordionButtons!: QueryList<ElementRef<HTMLButtonElement>>;

	@HostListener('window:scroll')
	onWindowScroll(): void {
		this.showScrollTop = window.scrollY > 300;
	}

	scrollToTop(): void {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	constructor(
		private readonly themeService: ThemeService,
		private readonly apiService: ApiService,
		private readonly router: Router,
		private readonly dataService: StepsDataService,
		private readonly stepService: StepProgressService,
	) {}

	ngOnInit(): void {
		this.themeService.setTenant(TENANT_ID);
		this.themeService.init();

		restoreSession();
		this.dataService.iniziaNuovoPreventivo();

		this.apiService.elencoGruppiProdotti(TENANT_ID).subscribe({
			next: (res) => { this.gruppi = res; },
			error: (err) => console.warn('[LandingImatra] elencoGruppiProdotti error:', err),
		});

		this.apiService.elencoTipiClienti().subscribe({
			next: (res) => sessionStorage.setItem('tipiClienti', JSON.stringify(res)),
			error: () => {},
		});
	}

	ngAfterViewInit(): void {
		this.accordionButtons.forEach((buttonRef) => {
			const button = buttonRef.nativeElement;
			const icon = button.querySelector('i');
			const collapseId = button.getAttribute('data-bs-target');

			if (collapseId && icon) {
				const collapseElement = document.querySelector(collapseId);
				if (collapseElement) {
					collapseElement.addEventListener('show.bs.collapse', () => {
						icon.classList.remove('bi-plus');
						icon.classList.add('bi-dash');
					});
					collapseElement.addEventListener('hide.bs.collapse', () => {
						icon.classList.remove('bi-dash');
						icon.classList.add('bi-plus');
					});
				}
			}
		});
	}

	selezionaGruppo(gruppo: ProductGroup): void {
		sessionStorage.setItem('gruppoSelezionato', JSON.stringify(gruppo));
		this.apiService.elencoParametriProdotti().subscribe((res) => {
			if (res?.length) {
				sessionStorage.setItem('parametriProdotto', JSON.stringify(res));
				this.router.navigate(['/steps-verifica']);
			} else {
				sessionStorage.setItem('parametriProdotto', JSON.stringify([]));
				this.apiService.elencoProdottiPerTenant(TENANT_ID, 'it', gruppo.idProductGroup).subscribe((prodotti) => {
					sessionStorage.setItem('listaProdotti', JSON.stringify(prodotti));
					this.stepService.markStepCompleted('steps-verifica', 'step-uno');
					this.router.navigate(['/steps-verifica/step-due']);
				});
			}
		});
	}

	onSubmitContatti(): void {}

	scrollTo(anchorId: string): void {
		const el = document.getElementById(anchorId);
		if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}
